// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import legalCaseDeadlineEntity from './entities/legal-case-deadline.json';
import legalCaseDeadlineMenu from '../pages/legal-case-deadline/menu.json';
import legalCaseDeadlineFullForm from '../pages/legal-case-deadline/forms/full.json';
import legalCaseDeadlineContextForm from '../pages/legal-case-deadline/forms/context.json';
import legalCaseDeadlineMiniForm from '../pages/legal-case-deadline/forms/mini.json';
import legalCaseDeadlineLookupForm from '../pages/legal-case-deadline/forms/lookup.json';
import legalCaseDeadlineTableView from '../pages/legal-case-deadline/views/table.json';
import legalCaseDeadlineCardsView from '../pages/legal-case-deadline/views/cards.json';
import legalCaseDeadlineDashboardView from '../pages/legal-case-deadline/views/dashboard.json';

/** Тип запису «Процесуальний строк» зі сторінками пакета: меню, форми та подання з pages/legal-case-deadline/. */
export const legalCaseDeadlineDefinition: IRecordTypeDefinition = {
  ...legalCaseDeadlineEntity,
  views: assembleViewSet({
      table: legalCaseDeadlineTableView,
      cards: legalCaseDeadlineCardsView,
      dashboard: legalCaseDeadlineDashboardView,
  }),
  form: legalCaseDeadlineFullForm,
  forms: { full: legalCaseDeadlineFullForm, context: legalCaseDeadlineContextForm, mini: legalCaseDeadlineMiniForm, lookup: legalCaseDeadlineLookupForm },
  menu: legalCaseDeadlineMenu,
} as IRecordTypeDefinition;
